<template>
  <v-select
    v-model="park"
    class="mt-2 mx-2"
    :label="$t('employees.park')"
    :loading="loading"
    :items="parks"
    item-value="id"
    item-text="name"
    :rules="[isRequired]"
    :disabled="isEdit ? !$can('auto_park_edit') : false"
  />
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: Number,
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    park: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
    parks() {
      return this.$store.state.parks.list;
    },
  },
  methods: {
    isRequired(v) {
      return !!v || this.$t('common.fields.validation.field.required');
    },
  },
  async created() {
    this.loading = true;
    await this.$store.dispatch('parks/fetchList');
    this.loading = false;
  },
};
</script>

<style></style>
